import axios from 'axios';

import { uiActions } from './ui-slice';
import { appConfigActions } from './appConfig-slice';

import {
  API_TOKEN_URL,
  CLIENT_ID,
  CLIENT_SECRET,
  CLIENT_USERNAME,
  CLIENT_PASSWORD,
} from '../constants/constants';

export const fetchToken = () => {
  return async (dispatch) => {
    const formData = {
      grant_type: 'password',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      username: CLIENT_USERNAME,
      password: CLIENT_PASSWORD,
    };

    axios
      .post(API_TOKEN_URL, formData)
      .then(({ data }) => {
        if (data.access_token) {
          dispatch(
            appConfigActions.setAppToken({
              token: data.access_token,
            }),
          );
        } else {
          throw new Error('No data returned from server.');
        }
        dispatch(uiActions.clearLoaderStatus());
      })
      .catch((err) => {
        dispatch(uiActions.clearLoaderStatus());
        dispatch(uiActions.setErrorStatus({
          type: 'generic',
          title: '¡Algo ocurrió mal!',
          // eslint-disable-next-line max-len
          body: 'Ocurrió un error al intentar cargar la aplicación. Puedes volver a intentarlo o contactarnos via telefónica.',
        }));
        throw err;
      });
  };
};
